import { createTimeline, stagger, splitText } from '../../vendor/anime.esm.js';
import { DURATION, EASE, STAGGER, SPRING_PRESETS, resolveDuration, resolveStagger, BLUR, SUPPORTS_CLIP } from '../motion-tokens.js';

export const contentV1 = (el) => {
    // v1: texto-img — PRIMARIO: imagen reveal clipPath desde la derecha. SECUNDARIO: texto desde izq.
    const textCols = el.querySelectorAll('.content-text, .content-left, h2, h3, p');
    const image    = el.querySelector('.content-image, .content-right, img, .hero-media');
    const tl = createTimeline({ defaults: { ease: EASE.refined }, });

    // Estado inicial forzado (previene FOVC)
    textCols.forEach(t => { t.style.opacity = '0'; t.style.transform = 'translateX(-40px)'; t.style.filter = BLUR.normal; });
    if (image) { image.style.opacity = '0'; }

    // Secundario: texto entra desde la izquierda
    if (textCols.length) {
        tl.add(textCols, {
            opacity:    [0, 1],
            translateX: [-40, 0],
            filter:     [BLUR.normal, BLUR.none],
            delay:      stagger(resolveStagger(STAGGER.fast)),
            duration:   resolveDuration(DURATION.normal),
        }, 0);
    }

    // Primario: imagen se revela con cortina horizontal (después de dar espacio al texto)
    if (image) {
        if (SUPPORTS_CLIP) {
            tl.add(image, {
                clipPath: [
                    'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)',
                    'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'
                ],
                scale:    [1.08, 1],
                opacity:  [0, 1],
                duration: 1800,
                ease:     SPRING_PRESETS.cinematic,
            }, 400); // 400ms delay para dar protagonismo al texto
        } else {
            tl.add(image, {
                opacity:    [0, 1],
                translateX: [60, 0],
                filter:     [BLUR.heavy, BLUR.none],
                duration:   resolveDuration(DURATION.slow),
            }, 300);
        }
    }

    return tl;
};

export const contentV2 = (el) => {
    // v2: stack — PRIMARIO: pull-quote splitText por palabras.
    const title    = el.querySelector('h2, h3, .content-title');
    const pullQuote = el.querySelector('blockquote, .pull-quote, .quote, .highlight-text');
    const body     = el.querySelector('p:not(.pull-quote), .content-body, .content-text');
    const tl = createTimeline({ defaults: { ease: EASE.refined }, });

    // Paso 1: Título fade-up
    if (title) tl.add(title, {
        opacity:    [0, 1],
        translateY: [20, 0],
        filter:     ['blur(3px)', 'blur(0px)'],
        duration:   resolveDuration(DURATION.normal),
    });

    // Paso 2 (PRIMARIO): pull-quote por palabras — esto es lo memorable
    if (pullQuote) {
        try {
            const split = splitText(pullQuote, { words: true, characters: false });
            if (split.words?.length) {
                tl.add(split.words, {
                    opacity:    [0, 1],
                    translateY: [12, 0],
                    delay:      stagger(60),
                    duration:   resolveDuration(DURATION.normal),
                    ease:       EASE.refined,
                }, '-=200');
            }
        } catch(e) {
            // Fallback sutil si splitText falla
            tl.add(pullQuote, {
                opacity:    [0, 1],
                translateY: [15, 0],
                duration:   resolveDuration(DURATION.slow),
            }, '-=200');
        }
    } else if (title) {
        // Sin pull-quote: subtitle stagger
        const subtitle = el.querySelector('.subtitle, h4, .content-subtitle');
        if (subtitle) tl.add(subtitle, {
            opacity:    [0, 1],
            translateY: [15, 0],
            duration:   resolveDuration(DURATION.normal),
        }, '-=300');
    }

    // Paso 3 (secundario): cuerpo de texto aparece después
    if (body) tl.add(body, {
        opacity:    [0, 1],
        translateY: [10, 0],
        duration:   resolveDuration(DURATION.normal),
    }, '-=200');

    return tl;
};

export const contentV3 = (el) => {
    // v3: img-texto — Inverso de v1: imagen desde izquierda, texto desde derecha.
    const textCols = el.querySelectorAll('.content-text, .content-right, h2, h3, p');
    const image    = el.querySelector('.content-image, .content-left, img, .hero-media');
    const tl = createTimeline({ defaults: { ease: EASE.refined }, });

    // Estado inicial forzado (previene FOVC)
    textCols.forEach(t => { t.style.opacity = '0'; t.style.transform = 'translateX(40px)'; t.style.filter = BLUR.normal; });
    if (image) { image.style.opacity = '0'; }

    if (image) {
        if (SUPPORTS_CLIP) {
            tl.add(image, {
                clipPath: [
                    'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)',
                    'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'
                ],
                scale:    [1.08, 1],
                opacity:  [0, 1],
                duration: 1800,
                ease:     SPRING_PRESETS.cinematic,
            }, 150);
        } else {
            tl.add(image, {
                opacity:    [0, 1],
                translateX: [-60, 0],
                filter:     ['blur(4px)', 'blur(0px)'],
                duration:   resolveDuration(DURATION.slow),
            }, 0);
        }
    }

    // Secundario: texto desde la derecha
    if (textCols.length) {
        tl.add(textCols, {
            opacity:    [0, 1],
            translateX: [40, 0],
            filter:     ['blur(3px)', 'blur(0px)'],
            delay:      stagger(resolveStagger(STAGGER.fast)),
            duration:   resolveDuration(DURATION.normal),
        }, 100);
    }

    return tl;
};
